
import { takeEvery, call, put, all } from 'redux-saga/effects';
import api from "../apis"
import config from '../config';
import { auth, loading, onboarding, toast, user, tickets, admin, projects } from "../types"
import { getRootDomain, setJWTToken } from '../utils/common';


export function* resetReduxStore(action) {
    yield all([
        yield put({ type: auth.RESET_AUTH_STORE_REQUEST }),
        yield put({ type: onboarding.RESET_ONBOARDING_STORE_REQUEST }),
        yield put({ type: projects.RESET_PROJECTS_STORE_REQUEST }),
        yield put({ type: tickets.RESET_TICKETS_STORE_REQUEST }),
        yield put({ type: user.RESET_USERS_STORE_REQUEST }),
        yield put({ type: admin.RESET_ADMIN_STORE_REQUEST }),
    ]);
}

export function* resetAuthStore(action) {
    yield put({ type: auth.RESET_AUTH_STORE_SUCCESS, payload: {} });
}

export function* registerWithMobile(action) {
    const { form, register_as, formName, navigate, gtag = false } = action.payload;
    let mobile = form.mobile;
    try {
        yield put({ type: loading.FORM_BUTTON_LOADING, payload: { formName, isLoading: true } });
        yield put({ type: auth.AUTH_ERROR_REQUEST, payload: undefined });
        const response = yield call(api.user.registerWithMobile, {}, {}, {}, { mobile, register_as });
        if (response.data.code === 201) {
            yield put({ type: auth.GET_REGISTER_MOBILE_SUCCESS, payload: response.data });
			if (gtag) {
                gtag();
            }
            navigate('/otp');
        } else {
            if (response.data.code === 400 && response.data.message?.mobile[0] === 'The mobile has already been taken.') {
                yield put({
                    type: auth.GET_OTP_REQUEST,
                    payload: { mobile: mobile, skip: true, bank_otp: 0, amount: undefined, source_url: false, formName: formName, navigate: navigate },
                });
            }
            yield put({ type: auth.AUTH_ERROR_REQUEST, payload: response.data.message.mobile[0] });
        }
    } catch (error) {
        yield put({ type: auth.GET_REGISTER_MOBILE_FAILURE, payload: error });
    }
    yield put({ type: loading.FORM_BUTTON_LOADING, payload: { formName, isLoading: false } });
}

export function* signUpWithOtp(action) {
    const { formdata, otp, logged_in_from, formName, navigate, setGtag } = action.payload;
    let { mobile } = formdata;
    try {
        yield put({ type: loading.FORM_BUTTON_LOADING, payload: { formName, isLoading: true } });
        const response = yield call(api.user.signUpWithOtp, {}, {}, {}, { mobile, otp, logged_in_from });
        if (response.data.code === 200) {
            let userDetails = response.data.data.user;
            const rootDomain = getRootDomain();
            setJWTToken({ token: response.data.data.token, options: { domain: rootDomain } });
            yield put({ type: user.USER_PROFILE_REQUEST, payload: {} });
            let yieldAll = [];
            if (userDetails.role.id === 4 && userDetails.status < 2.5) {
                yieldAll.push(yield put({ type: onboarding.CUSTOMER_ONBOARDING_STATUS_REQUEST }));
            }
            yieldAll.push(yield put({ type: user.USER_PROFILE_SUCCESS, payload: response.data.data.user }));
            yield all(yieldAll);
            yield put({ type: onboarding.SAVE_CUSTOMER_ONBOARDING_DETAILS_REQUEST, payload: { userDetails, formdata, navigate, setGtag } });
            setGtag && setGtag('sign-upWith-otp');
        } else {
            yield put({ type: auth.AUTH_ERROR_REQUEST, payload: response.data.message });
            yield put({ type: loading.FORM_BUTTON_LOADING, payload: { formName, isLoading: false } });
        }
    } catch (error) {
        yield put({ type: auth.GET_SIGNUP_OTP_FAILURE, payload: error });
        yield put({ type: loading.FORM_BUTTON_LOADING, payload: { formName, isLoading: false } });
    }
}

export function* getLoginOTP(action) {
    const { mobile, skip, bank_otp, amount, source_url, formName, navigate, gtag = false } = action.payload;

    try {
        yield put({ type: loading.FORM_BUTTON_LOADING, payload: { formName, isLoading: true } });
        const response = yield call(api.user.getOTP, {}, {}, {}, { mobile, skip, bank_otp, amount, source_url });
        if ([200].includes(response.data.code)) {
            yield put({ type: auth.GET_OTP_SUCCESS, payload: response.data });
            gtag && gtag();
            navigate('/otp');
        } else {
            yield put({ type: auth.GET_OTP_FAILURE, payload: response.data.message });
        }
    } catch (error) {
        yield put({ type: auth.GET_OTP_FAILURE, payload: error });
    }
    yield put({ type: loading.FORM_BUTTON_LOADING, payload: { formName, isLoading: false } });
}

export function* loginWithOTP(action) {
    const { mobile, auth_otp, logged_in_from, skip, formName, navigate, setGtag } = action.payload;
    try {
        yield put({ type: loading.FORM_BUTTON_LOADING, payload: { formName, isLoading: true } });
        const response = yield call(api.user.signInWithOTP, {}, {}, {}, { mobile, auth_otp, skip, logged_in_from });
        if (response.data.code === 200) {
            if ([4, 14, 15].includes(response?.data?.data?.user?.role?.id)) {
                const rootDomain = getRootDomain();
                setJWTToken({
                    token: response.data.data.token,
                    options: { domain: rootDomain },
                });
                yield put({ type: toast.SEND_TOAST, payload: { status: 'success', message: 'User logged in successfully' } });
                yield put({ type: user.USER_PROFILE_REQUEST, payload: {} });
                setGtag && setGtag('Login-with-otp');
                yield put({ type: tickets.TICKETS_LIST_REQUEST, payload: { customerId: response.data.data.user?.customer_id, count: true, activeTab: 'alltickets', navigate } });
            } else {
                yield put({ type: toast.SEND_TOAST, payload: { status: 'danger', message: 'You are not authorised to access this portal !' } });
                navigate('/userdetails');
                yield put({ type: loading.FORM_BUTTON_LOADING, payload: { formName, isLoading: false } });
            }
        } else {
            yield put({ type: auth.AUTH_ERROR_REQUEST, payload: response.data.message });
            yield put({ type: loading.FORM_BUTTON_LOADING, payload: { formName, isLoading: false } });
        }
    } catch (error) {
        yield put({ type: auth.LOGIN_WITH_OTP_FAILURE, payload: error });
        yield put({ type: loading.FORM_BUTTON_LOADING, payload: { formName, isLoading: false } });
    }
}

export function* resendOtp(action) {
    const { mobile, register_as, resendFor, skip = true, bank_otp = 0, amount, source_url = false } = action.payload;
    try {
        if (resendFor === 'registerWithMobile') {
            yield put({ type: auth.AUTH_ERROR_REQUEST, payload: undefined });
            const response = yield call(api.user.registerWithMobile, {}, {}, {}, { mobile, register_as });
            if (response.data.code === 201) {
                yield put({ type: auth.GET_REGISTER_MOBILE_SUCCESS, payload: response.data });
                yield put({ type: toast.SEND_TOAST, payload: { status: 'success', message: `Verification code sent to ${mobile}` } });
            } else {
                yield put({ type: auth.AUTH_ERROR_REQUEST, payload: response.data.message.mobile[0] });
            }
        } else if (resendFor === 'loginMobile') {
            try {
                const response = yield call(api.user.getOTP, {}, {}, {}, { mobile, skip, bank_otp, amount, source_url });
                if ([200].includes(response.data.code)) {
                    yield put({ type: auth.GET_OTP_SUCCESS, payload: response.data });
                    yield put({ type: toast.SEND_TOAST, payload: { status: 'success', message: `Verification code sent to ${mobile}` } });
                } else {
                    yield put({ type: auth.GET_OTP_FAILURE, payload: response.data.message });
                }
            } catch (error) {
                yield put({ type: auth.GET_OTP_FAILURE, payload: error });
            }
        }
    } catch (error) {
        yield put({ type: auth.GET_REGISTER_MOBILE_FAILURE, payload: error });
    }
}

export function* signOutUser(action) {
    const { navigate } = action.payload;
    const rootDomain = getRootDomain();
    try {
        yield call(api.user.signOut, {});
        localStorage.clear();
        setJWTToken({ options: { domain: rootDomain, expires: new Date() } });
        yield put({ type: auth.RESET_REDUX_STORE_REQUEST, payload: {} });
        yield put({ type: user.REMOVE_FROM_USERS_STORE_REQUEST, payload: { type: 'USER_PROFILE_SUCCESS' } });
        window.open(config?.webSite, '_self');
        navigate(0);
    } catch (error) {
        localStorage.clear();
        setJWTToken({ options: { domain: rootDomain, expires: new Date() } });
        yield put({ type: auth.RESET_REDUX_STORE_REQUEST, payload: {} });
        window.open(config?.webSite, '_self');
        yield put({ type: auth.SIGN_OUT_FAILURE, payload: { message: error } });
    }
}


export default function* authSaga() {
	yield takeEvery(auth.GET_REGISTER_MOBILE_REQUEST, registerWithMobile)
	yield takeEvery(auth.RESET_REDUX_STORE_REQUEST, resetReduxStore)
	yield takeEvery(auth.RESET_AUTH_STORE_REQUEST, resetAuthStore)
	yield takeEvery(auth.GET_SIGNUP_OTP_REQUEST, signUpWithOtp)
	yield takeEvery(auth.GET_RESEND_OTP_REQUEST, resendOtp)
	yield takeEvery(auth.LOGIN_WITH_OTP_REQUEST, loginWithOTP)
	yield takeEvery(auth.SIGN_OUT_REQUEST, signOutUser)
	yield takeEvery(auth.GET_OTP_REQUEST, getLoginOTP)
}
